/**
 * @file
 * Switch buttons on locations and dispensary pages.
 */

const $context = $('.location-buttons, .dispensary-buttons', context);
$context.once('locations-dispensary-page-buttons').each((index, el) => {
  const $this = $(el);
  const $body = $('body');

  $this
    .find('.location-button-map, .dispensary-button-map')
    .click(() => $body.addClass('is-map-open is-fixed'));
  $this
    .find('.location-button-list, .dispensary-button-list')
    .click(() => $body.removeClass('is-map-open is-fixed'));
});
